import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { DashboardLayoutComponent } from './layouts/dashboard-layout/dashboard-layout.component';
import { PublicLayoutComponent } from './layouts/public-layout/public-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: PublicLayoutComponent,
    loadChildren: () => import('./pages/public/public.route').then((mod) => mod.PUBLIC_ROUTES),
  },
  {
    path: 'authorization',
    component: DashboardLayoutComponent,
    canActivate: [authGuard],
    loadChildren: () =>
      import('./pages/authorization/authorization.route').then((mod) => mod.AUTHORIZATION_ROUTES),
  },
];
